import { ElMessageBox } from "element-plus";
import { t } from "@/utils";
export const useDel = async (callback) => {
  try {
    await ElMessageBox.confirm(t("action.delete"), t("action.tips"), {
      confirmButtonText: t("action.confirmBtn"),
      cancelButtonText: t("action.cancel"),
      type: "warning",
    });
    callback();
  } catch (err) {
    console.log(err);
  }
};
